export default __webpack_public_path__ + "static/media/LOGO 2.9b788abc.jpg";